import '../pages/Home.css';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { useUserProfile } from "../context/user/useProfileProfile";

const universal_logo = require('../assets/logos.png');
const privacyOptOut = require("../assets/privacyoptions29x14.png");

const Footer = () => {
  const navigate = useNavigate();
  const { userProfile, logout } = useUserProfile();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = async () => {
    // Persist collections before clearing userProfile
    try {
      const userProfile = JSON.parse(localStorage.getItem("userProfile") || '{}');
      if (userProfile && Array.isArray(userProfile.collections) && userProfile.collections.length > 0) {
        // Save to medallionCollection key
        import("../../utils/profileUtils").then(utils => {
          utils.saveMedallionCollection(userProfile.collections);
        });
      }
    } catch (e) {
      // Fallback: ignore errors
    }
    // Attempt SDK logout if available
    try {
      if (window.nbc?.identity?.unauthenticate) {
        const result = window.nbc.identity.unauthenticate();
        if (result instanceof Promise) {
          await result;
        }
      }
    } catch (err) {
      // Log SDK unauth error
      console.error("Error during SDK logout:", err);
    }
    // Clear app-specific session/profile state
    localStorage.removeItem("userProfile");
    sessionStorage.removeItem("userProfile");

    logout();

    // TODO: Clear any additional global context/auth state if used
    navigate("/");
  };

  return (
    <Box>
      <img src={universal_logo} className='universal-logo2' style={{
        width: '90%',
        maxWidth: 500
      }} alt="Logo"/>
      <footer style={{
        padding: '20px 0',
        paddingTop: isSmallScreen ? '3px' : '20px',
        paddingBottom: isSmallScreen ? '80px': '20px',
        fontSize: isSmallScreen ? '12px' : '12px' }}>
        <div>
          <a href="https://www.nbcuniversalprivacy.com/privacy/cookies#accordionheader2"
            style={isSmallScreen ? styles.smLink : styles.link} target="_blank">
            Ad Choices
          </a>
        </div>
        <div>
          <a href="https://www.nbcuniversalprivacy.com/privacy"
            style={isSmallScreen ? styles.smLink : styles.link} target="_blank">
            New Privacy Policy
          </a>
        </div>
        {/* <DoNotDisturbOnIcon style={styles.icon} /> */}
        {/* <a href="https://www.nbcuniversal.com/privacy/notrtoo"
          style={isSmallScreen ? styles.smLink : styles.link} target="_blank">
          Your Privacy Choices
        </a> */}
        <div>
          <span>
            <img src={privacyOptOut} alt="Your Privacy Choices" style={{
              marginRight: 5, marginLeft: isSmallScreen ? 3 : 18, float: 'left'
            }} /> 
            <button id="ot-sdk-btn" className="ot-sdk-show-settings"
              style={{
                background: 'none', padding: 0, margin: 0, fontWeight: 200, fontSize: isSmallScreen ? '12px' : '12px'
              }}>
              Your Privacy Choices
            </button>
          </span>
        </div>
        <div>
          <a href="https://www.nbcuniversalprivacy.com/privacy/california-consumer-privacy-act"
            style={isSmallScreen ? styles.smLink : styles.link} target="_blank">
            CA Notice
          </a>
        </div>
        <div>
          <a href="https://www.nbcuniversal.com/terms"
            style={isSmallScreen ? styles.smLink : styles.link} target="_blank">
            Terms of Service
          </a>
        </div>
        {(userProfile?.isLoggedIn) && (
          <button
            onClick={handleLogout}
            className="text-white/90 text-xs hover:text-white transition-colors mt-2 !bg-transparent"
            style={{
              background: 'none',
              margin: 0,
              marginLeft: isSmallScreen ? 5 : 18,
              padding: 0,
              height: 'auto',
              width: 'auto',
              fontSize: 12,
              color: '#ffffff'
            }}
          >
            Log out
          </button>
        )}
      </footer>
    </Box>
  );
};

const styles = {
  footer: {
    position: 'fixed', // Stick to the bottom
    bottom: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f1f1f1',
    padding: '10px 0',
  },
  link: {
    margin: '0 20px',
    textDecoration: 'none',
    color: '#fff',
    textAlign: 'center'
  },
  smLink: {
    margin: '0 5px',
    textDecoration: 'none',
    color: '#fff',
    textAlign: 'center'
  },
  icon: {
    position: 'absolute',
    color: '#fff', // Color of the icon
    left: '48rem',
    width: '1%',
  },
};

export default Footer;